import createInterceptor from './Interceptor';
import apiUrls from '@/config/apiUrls';

const baseURL = apiUrls.DASHBOARD_MGR_URL;

const axiosInstance = createInterceptor({
  baseURL,
});

export default axiosInstance;
